import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './scss/index.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { QueryClient, QueryClientProvider } from 'react-query';
import { App } from './App';
import Firebase, { FirebaseContext } from './components/Firebase';

const firebase = new Firebase();
const queryClient = new QueryClient();
if (process.env.REACT_APP_ENV === 'production') {
  Sentry.init({
    dsn: 'https://11f3d3b1af4a49a4bb5627c2e93853fa@sentry-insync.coreline.hr/3'
  });
}
ReactDOM.render(
  <FirebaseContext.Provider value={firebase}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <App />
      </Router>
    </QueryClientProvider>
  </FirebaseContext.Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
